import Vue from 'vue'
import VueJWT from 'vuejs-jwt'
import App from './App.vue'
import axios from 'axios'
import router from './router.js'

import io from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'
// Vue.use(VueSocketIO, io('https://mcfapi.herokuapp.com'))
Vue.use(new VueSocketIO({ connection: io('https://mcfapi.herokuapp.com')}))
import Notifications from 'vue-notification'
import Vuelidate from 'vuelidate'
import { CircleSpinner, BounceSpinner } from 'vue-spinners'
import {ClientTable} from 'vue-tables-2';
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker';
import VModal from 'vue-js-modal'


// Static files
import  './assets/static/css/ionicons.min.css';
import  './assets/static/css/core.min.css';
import  './assets/static/css/app.min.css';
import  './assets/static/css/custom.css';
import  './assets/static/css/vue-multiselect.min.css';


Vue.use(VueJWT) 
Vue.use(ClientTable);
Vue.use(Notifications)
Vue.use(Vuelidate)
Vue.use(VModal)

Vue.component('circle-spin', CircleSpinner)
Vue.component('datepicker', Datepicker)
Vue.component('bounce', BounceSpinner)
Vue.component('multiselect', Multiselect)

function retrieveToken(name) {
    return localStorage.getItem(name)
}

// For API calls
axios.defaults.baseURL = 'https://mcfapi.herokuapp.com/api/v1';
axios.interceptors.request.use(function(config) {
  const token = retrieveToken(window.btoa('userToken'))
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

router.beforeEach((to, from, next) => {
  let userToken = retrieveToken(window.btoa('userToken'));
  if (to.matched.some(record => record.meta.reqToken)) {
    // console.log("requires token");
    if (userToken === null) {
      // console.log("not logged in");
      next("/");
    } else {
      // console.log("token is :", userToken);
      next();
    }
  } else {
    // console.log("requires no token");
    next();
  }
});


export const Bus = new Vue();

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
